import React, {FC, useState, Dispatch, SetStateAction } from 'react';
import clsx from 'clsx';
import {useIntl} from 'react-intl';
import {StateForm} from './StateForm'
import { OpState, SupplierOperation } from '../../core/_models';
//import { updateBulkOrderState } from '../../core/_requests';
import {KTIcon} from '@/_metronic/helpers';

interface Props {
  order: SupplierOperation
  setOrder: Dispatch<SetStateAction<SupplierOperation | undefined>>
}

const Timeline: FC<Props> = ({ order, setOrder}) => {
  const couldUpdate = ['VALIDATED', 'PAID'];
  const intl = useIntl();
  const [state, setState] = useState<OpState | undefined>()

  return (
    <div className="timeline">
      {(order?.states || []).map((s: OpState, index: number) => (
        <div key={`state-${index}`} className='timeline-item'>
          <div className='timeline-line w-40px'></div>

          <div className='timeline-icon symbol symbol-circle symbol-40px'>
            <div className='symbol-label'>
              <i className={clsx('fa fa-genderless fs-1', {
                'text-info': ['INIT', 'UPDATED'].includes(s.state),
                'text-dark': s.state === 'PENDING_VALIDATION',
                'text-success': ['VALIDATED', 'COMPLETED'].includes(s.state),
                'text-primary': s.state === 'PAID',
                'text-danger': s.state === 'REJECTED',
                'text-warning': s.state === 'PROCESSING',
              })}></i>
            </div>
          </div>

          <div className='timeline-content mb-5'>
            <div className='overflow-auto pe-3'>
              {state?.state === s.state ? (
                <StateForm
                  order={order}
                  setOrder={setOrder}
                  state={state}
                  cb={() => setState(undefined)}
                />
              ) : (
                <>
                  <div className='d-flex align-items-center justify-content-between fs-5 fw-bold'>
                    <span>{s.state}</span>
                    {couldUpdate.includes(s.state) && (
                      <button
                        type="button"
                        className="appearance-none bg-transparent border-0 p-0 m-0"
                        onClick={() => setState(s)}
                      >
                        <KTIcon iconName='calendar-edit' className="fs-1 text-danger" />
                      </button>
                    )}
                  </div>

                  <div className='d-flex align-items-center fs-6'>
                    <div className='text-muted me-2 fs-7'>
                      {intl.formatDate(s.date, {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric'
                      })}
                    </div>
                  </div>
                </>
              )} 
            </div>
          </div>
        </div>
      ))}
    </div>

  )
}

export default Timeline
